<template>
  <b-modal id="submitFile" :centered="true" title="Do you want to submit the claim?" :hide-footer="true" size="md" @hidden="resetForm" no-close-on-backdrop>
    <div>
        <label class="plan_name_label">Plan Name: </label>
        <p class="prudential_plan_name">{{ claimData.plan_name }}</p>
      </div>
    <div v-if="claimData.is_LifeOr7kEnabled" class="date-picker-wrap mb-3">
      <label for="claim-date" class="d-block">Death Date <span style="color: red;">*</span></label>
      <date-picker
        v-model="death_date"
        type="date"
        placeholder="Enter Death Date"
        :disabled-date="disableDates"
      ></date-picker>
      <span class="error_message d-block" v-if="formTouched && !$v.death_date.required">Death date is required</span>
    </div>
    <div class="file-content-wrap">
      <p class="mb-3">
        The file<span v-if="files.length > 1">s</span> you want to upload:
      </p>
      <div class="d-flex flex-wrap">
        <div v-for="file in files" :key="file.id" class="mb-2 pr-0 mr-2">
          <div class="file-name-list">
            <a :href="file.filepath" target="_blank" class="clr-active">{{
              file.filename
            }}</a>
          </div>
        </div>
      </div>
    </div>
    

    <div class="d-flex justify-content-center">
      <div class="cancel-btn mr-3">
        <button @click="hideModal">Cancel</button>
      </div>
      <div class="submit-btn">
        <button @click="submit">Submit</button>
      </div>
    </div>
  </b-modal>
</template>


<script>
import axios from 'axios';
import helper from "@/resource/Helper";
import { action_origin } from '../../utlis/constant';
import { required } from 'vuelidate/lib/validators'

export default {
  name: "FileSubmitModal",
  props: {
    files: {
      type: Array,
      default: () => [],
    },
    claimData: {
      type: Object,
    },
  },
  data() {
    return {
      death_date: "",
      formTouched: false,
    };
  },
  validations:{
    death_date:{required},
  },
  
  methods: {
    hideModal() {
      this.$bvModal.hide('submitFile');
    },
    disableDates(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0); 
      return date > today;
    },
    onInput() {
      this.formTouched = true; 
    },
    resetForm() {
      this.death_date = "";
      this.formTouched = false;
      this.$v.$reset();
    },
    submit() {      
      if (this.claimData.is_LifeOr7kEnabled) {
        this.submitClaimData();
      } else {
        this.submitData();
      }
    },
    submitClaimData() {
      this.formTouched = true;
      this.$v.$touch();
      if(this.$v.$invalid){
        return false;
      }
      let loader = this.$loading.show();
      const url = "prudential-claim/store-death-date";
      const formattedDate = new Date(this.death_date).toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric"
      })
      const payload = {
        death_date: formattedDate
      };

      axios
        .post(url, payload)
        .then((response) => {
          if (response.data?.status === "success") {
            this.submitData();
          } else {
            helper.infoMessage(this, "error", response.data?.message || "Unknown error");
          }
        })
        .catch((error) => {
          const errorMessage = error.response.data.errors.death_date[0] || "Submission failed.";
          helper.infoMessage(this, "error", errorMessage);
        })
        .finally(() => {
          loader.hide();
        });
    },
    submitData() {   

      let loader = this.$loading.show();
      let url = 'prudential-claim/submit-claim';

      let payload = {
        claim_id: this.files[0].claim_id,
        policy_id: this.claimData.policy_id,
        plan_id: this.claimData.pid,
        submitted_id: this.$store.getters.memberId,
        submitted_by: action_origin,
      };

      axios.post(url, payload)
        .then((response) => {
          if (response.data.status === "success") {
            helper.infoMessage(this, response.data.status, response.data.message);
          }
          this.$parent.getClaimList();
          this.hideModal();
        })
        .catch((error) => {
          if (error.response && error.response.data.status === "error") {
            helper.infoMessage(this, "error", error.response.data.message);
          }
          this.$parent.getClaimList();
          this.hideModal();
        })
        .finally(() => {
          loader.hide();
        });
    },
  },
};

</script>
<style scoped>
.error_message{
  color:#dc3545;
  margin-top: 5px;
}
.plan_name_label{
  margin-bottom: 0;
}

</style>
